import React from 'react'
import { Tabs, Tab } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useIntl } from 'react-intl'
import { i18nMessages } from '../../Logic/CodeAccessible.i18n.Messages'
import { CapeeshColors } from '../../assets/ColorPalette'

const useStyles = makeStyles(() => ({
    tabs: {
        borderBottom: `1px solid ${CapeeshColors.Gray4}`,
        marginTop: '25px',
    },
    tab: {
        textTransform: 'none',
        fontFamily: 'Rubik',
        fontWeight: 500,
        fontSize: '16px',
    },
}))

export const CourseStatisticsTab = {
    Overview: 0,
    Courses: 1,
}

/**
 * Shared tab bar for the two statistics pages. Navigation is by route rather than local state so
 * an admin can link a colleague straight to the course view.
 */
const CourseStatisticsTabBar = (props) => {
    const classes = useStyles()
    const intl = useIntl()

    return (
        <Tabs
            className={classes.tabs}
            value={props.activeTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={(event, value) => props.onChange(value)}>
            <Tab className={classes.tab} label={intl.formatMessage(i18nMessages.courseStatisticsTabOverview)} />
            <Tab className={classes.tab} label={intl.formatMessage(i18nMessages.courseStatisticsTabCourses)} />
        </Tabs>
    )
}

export default CourseStatisticsTabBar
